import Vue from 'vue'
import store from '../store'
import Router from 'vue-router'
import NProgress from 'nprogress'

Vue.use(Router)

const routes = [
    {
        path: '/',
        redirect: '/signin',
    },
    {
        name: 'Response',
        path: '/response/:pulse/:uid/:response',
        component: () => import('@/views/Researchs/Response'),
        meta: { layout: 'Response', public: true, title: 'Resposta' },
    },
    {
        name: 'Comment',
        path: '/response/:pulse/:uid/:response/comment',
        component: () => import('@/views/Researchs/Comment'),
        meta: { layout: 'Response', public: true, title: 'Comentário' },
    },
    {
        path: '/signin',
        component: () => import('@/views/Session/Signin'),
        meta: { layout: 'Session', public: true, title: 'Login' },
    },
    {
        path: '/signup',
        component: () => import('@/views/Session/Signup'),
        meta: { layout: 'Session', public: true, title: 'Cadastro' },
    },
    {
        path: '/forgot',
        component: () => import('@/views/Session/Forgot'),
        meta: { layout: 'Session', public: true, title: 'Esqueci minha senha' },
    },
    {
        path: '/home',
        component: () => import('@/views/Home'),
    },
    {
        name: 'Profile',
        path: '/profile',
        component: () => import('@/views/Users/Profile'),
        meta: { title: 'Perfil', pages: [{ name: 'Perfil' }], level: 'user' },
    },
    {
        name: 'HappinessDashboard',
        path: '/happiness/dashboard',
        components: {
            default: () => import('@/views/Happiness/HappinessDashboard'),
            topBar: () => import('@/components/datePicker'),
        },
        meta: { title: 'Dashboard', pages: [{ name: 'Dashboard' }], level: 'admin' },
    },
    {
        name: 'HappinessSettings',
        path: '/happiness/settings',
        component: () => import('@/views/Happiness/HappinessSettings'),
        meta: { title: 'Configurações', pages: [{ name: 'Configurações' }], level: 'admin' },
    },
    {
        name: 'HappinessFeedbacks',
        path: '/happiness/feedbacks',
        component: () => import('@/views/Happiness/HappinessFeedbacks'),
        meta: { title: 'Feedbacks', pages: [{ name: 'Feedbacks' }], level: 'admin' },
    },
    {
        name: 'HappinessReports',
        path: '/happiness/reports',
        component: () => import('@/views/Happiness/HappinessReports/HappinessReports'),
        meta: { title: 'Relatórios', pages: [{ name: 'Relatórios' }], level: 'admin' },
    },
    {
        name: 'ScoreEvolutionReport',
        path: '/happiness/reports/score-evolution',
        component: () => import('@/views/Happiness/HappinessReports/ScoreEvolutionReport'),
        meta: {
            title: 'Relatórios / Evolução da Pontuação',
            pages: [
                {
                    name: 'Relatórios',
                    to: { name: 'HappinessReports' },
                },
                {
                    name: 'Evolução da Pontuação',
                },
            ],
            level: 'admin',
        },
    },
    {
        name: 'ParticipationEvolutionReport',
        path: '/happiness/reports/participation-evolution',
        component: () => import('@/views/Happiness/HappinessReports/ParticipationEvolutionReport'),
        meta: {
            title: 'Relatórios / Evolução da Participação',
            pages: [
                {
                    name: 'Relatórios',
                    to: { name: 'HappinessReports' },
                },
                {
                    name: 'Evolução da Participação',
                },
            ],
            level: 'admin',
        },
    },
    {
        name: 'ScoreEvolutionReportByTeams',
        path: '/happiness/reports/score-evolution-teams',
        component: () => import('@/views/Happiness/HappinessReports/ScoreEvolutionReportByTeams'),
        meta: {
            title: 'Relatórios / Evolução da Pontuação por Equipes',
            pages: [
                {
                    name: 'Relatórios',
                    to: { name: 'HappinessReports' },
                },
                {
                    name: 'Evolução da Pontuação por Equipes',
                },
            ],
            level: 'admin',
        },
    },
    {
        name: 'ReportFeedbacksHome',
        path: '/happiness/reports/feedbacks-home',
        component: () => import('@/views/Happiness/HappinessReports/FeedbacksHome'),
        meta: {
            title: 'Relatórios / Feedbacks',
            pages: [
                {
                    name: 'Relatórios',
                    to: { name: 'HappinessReports' },
                },
                {
                    name: 'Feedbacks',
                },
            ],
            level: 'admin',
        },
    },
    {
        name: 'ReportFeedbacks',
        path: '/happiness/reports/feedbacks/:id',
        component: () => import('@/views/Happiness/HappinessReports/Feedbacks'),
        meta: {
            title: 'Relatórios / Feedbacks / Respostas',
            pages: [
                {
                    name: 'Relatórios',
                    to: { name: 'HappinessReports' },
                },
                {
                    name: 'Feedbacks',
                    to: { name: 'ReportFeedbacksHome' },
                },
                {
                    name: 'Respostas',
                },
            ],
            level: 'admin',
        },
    },
    {
        name: 'ReportMilestones',
        path: '/happiness/reports/milestones',
        component: () => import('@/views/Happiness/HappinessReports/Milestones'),
        meta: {
            title: 'Relatórios / Milestones',
            pages: [
                {
                    name: 'Relatórios',
                    to: { name: 'HappinessReports' },
                },
                {
                    name: 'Milestones',
                },
            ],
            level: 'admin',
        },
    },
    {
        name: 'Milestones',
        path: '/milestones',
        component: () => import('@/views/Milestones/Milestones'),
        meta: { title: 'Milestones', pages: [{ name: 'Milestones' }], level: 'admin' },
    },
    {
        name: 'Teams',
        path: '/teams/list',
        component: () => import('@/views/Teams/TeamsList'),
        meta: { title: 'Equipes', pages: [{ name: 'Equipes' }], level: 'admin' },
    },
    {
        name: 'Users',
        path: '/users/list',
        component: () => import('@/views/Users/UserList'),
        meta: { title: 'Usuários', pages: [{ name: 'Usuários' }], level: 'admin' },
    },
    {
        name: 'Help',
        path: '/help',
        component: () => import('@/views/Help/Help'),
        meta: { title: 'Ajuda', pages: [{ name: 'Ajuda' }], level: 'admin' },
    },
    {
        name: 'Plan',
        path: '/system/plan',
        component: () => import('@/views/System/Plan'),
        meta: { title: 'Plano', pages: [{ name: 'Plano' }], level: 'admin' },
    },
    {
        name: 'Notifications',
        path: '/system/notifications',
        component: () => import('@/views/System/Notifications'),
        meta: { title: 'Notificações', pages: [{ name: 'Notificações' }], level: 'admin' },
    },
    {
        name: 'Account',
        path: '/system/account',
        component: () => import('@/views/System/Account'),
        meta: { title: 'Conta', pages: [{ name: 'Conta' }], level: 'admin' },
    },
    {
        path: '/inactive',
        component: () => import('@/views/Error/InactiveUser'),
        meta: { layout: 'Error', title: 'Usuário Inativo', level: 'admin' },
    },
    {
        path: '/suspended',
        component: () => import('@/views/Error/Suspended'),
        meta: { layout: 'Error', title: 'Usuário Suspenso', level: 'admin' },
    },
    {
        path: '/canceled',
        component: () => import('@/views/Error/Canceled'),
        meta: { layout: 'Error', title: 'Conta Cancelada', level: 'admin' },
    },
    {
        path: '*',
        component: () => import('@/views/Error/404'),
        meta: { layout: 'Error', public: true, title: 'Página não encontrada' },
    },
]

const router = new Router({
    mode: 'history',
    linkActiveClass: 'open',
    routes,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
})

const setTitle = (to) => {
    const { meta } = to
    let title = 'Happiness Monitor'
    if (meta && meta.title) {
        title = meta.title
    }

    document.title = title
}

router.afterEach((to) => {
    setTitle(to)

    // Remove initial loading
    const gullPreLoading = document.getElementById('loading_wrap')
    if (gullPreLoading) {
        gullPreLoading.style.display = 'none'
    }
    // Complete the animation of the route progress bar.
    setTimeout(() => NProgress.done(), 500)
    // NProgress.done();
    // if (isMobile) {
    if (window.innerWidth <= 1200) {
        store.dispatch('changeSidebarProperties')
        if (store.getters.getSideBarToggleProperties.isSecondarySideNavOpen) {
            store.dispatch('changeSecondarySidebarProperties')
        }

        // if (store.getters.getCompactSideBarToggleProperties.isSideNavOpen) {
        //     store.dispatch('changeCompactSidebarProperties')
        // }
    } else {
        if (store.getters.getSideBarToggleProperties.isSecondarySideNavOpen) {
            store.dispatch('changeSecondarySidebarProperties')
        }

    // store.state.sidebarToggleProperties.isSecondarySideNavOpen = false;
    }
})

export default router
